import { render, staticRenderFns } from "./KZNumber.vue?vue&type=template&id=6db63a1d&scoped=true&"
import script from "./KZNumber.vue?vue&type=script&lang=js&"
export * from "./KZNumber.vue?vue&type=script&lang=js&"
import style0 from "./KZNumber.vue?vue&type=style&index=0&id=6db63a1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db63a1d",
  null
  
)

export default component.exports